import React from 'react';
import { ValueRegistryItem } from '../../../registry/value/ValueRegistryItem';
import { ValueRegistryCategory } from '../../../registry/value/ValueRegistryCategory';
import { Actor_ } from '../../../components/actor/Actor_';
export class ValuesMultipleChoice extends ValueRegistryCategory {
    label = 'MultipleChoice';
    constructor(parent) {
        super(parent);
        super.init();
    }
    mc_latestXClick = () => new ValueRegistryItem({
        parent: this,
        label: 'X of latest selection click',
        value: ({ questionMultipleChoice }) => {
            if (!questionMultipleChoice)
                return 0;
            if (!questionMultipleChoice.choiceSelections.latestSelection)
                return 0;
            if (!questionMultipleChoice.choiceSelections.latestSelection.event)
                return 0;
            return questionMultipleChoice.choiceSelections.latestSelection.event.stageXInUnits;
        }
    });
    mc_latestYClick = () => new ValueRegistryItem({
        parent: this,
        label: 'Y of latest selection click',
        value: ({ questionMultipleChoice }) => {
            if (!questionMultipleChoice)
                return 0;
            if (!questionMultipleChoice.choiceSelections.latestSelection)
                return 0;
            if (!questionMultipleChoice.choiceSelections.latestSelection.event)
                return 0;
            return questionMultipleChoice.choiceSelections.latestSelection.event.stageYInUnits;
        }
    });
    optionStruct = () => new ValueRegistryItem({
        parent: this,
        label: 'OptionStruct (by Number)',
        value: ({ questionMultipleChoice, at }) => {
            const i = at.valueOf.number1To10;
            if (questionMultipleChoice.options.length < i)
                return null;
            const actor = questionMultipleChoice.options[i - 1];
            return React.createElement(Actor_, { actor: actor, key: actor.tid });
        },
        params: { core: ['number1To10'] }
    });
    tableCellNumber = () => new ValueRegistryItem({
        parent: this,
        label: 'tableCellNumber',
        value: ({ aspect }) => {
            const cellAspect = aspect.actor.parent;
            const table = cellAspect.actor;
            if (table.type !== 'table')
                return 1;
            return table.cellAspectNameToCellNumber(cellAspect.name);
        }
    });
}
